import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { isCanada, removeSessionStorage, routerPush } from '@tcp/core/src/utils';
import { CONTACT_FORM } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.constant';
import Styles from '../styles/CreateAccountNewHeader.style';
import withStyles from '../../../../../../common/hoc/withStyles';
import { getDynamicLabelValues, renderLabel } from '../../../../../../../utils/labels/labelUtilty';
import { setContactFormValuesInSS } from '../../../../../CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';

const onBackClick = (saveExistingUserResponse, isFromCheckout) => {
  if (isFromCheckout) {
    saveExistingUserResponse('');
    setContactFormValuesInSS();
    removeSessionStorage(CONTACT_FORM);
    routerPush('/login-checkout', '/login-checkout');
  } else if (window.history && typeof window.history.back === 'function') {
    window.history.back();
  }
};

const CreateAccountNewHeader = ({
  className,
  emailIsNewRegisteredFlow,
  saveExistingUserResponse,
  isFromCheckout,
}) => {
  const getMyPlaceRewardsText = () => {
    return (
      <>
        <BodyCopy
          component="span"
          fontWeight="extrabold"
          fontSize={['fs11', 'fs14']}
          className="text-style-1"
          fontFamily="secondary"
        >
          {'My '}
        </BodyCopy>
        <BodyCopy
          component="span"
          fontWeight="extrabold"
          fontSize={['fs11', 'fs14']}
          className="text-style-2"
          fontFamily="secondary"
        >
          {'Place '}
        </BodyCopy>
        <BodyCopy
          component="span"
          fontWeight="extrabold"
          fontSize={['fs11', 'fs14']}
          className="text-style-3"
          fontFamily="secondary"
        >
          {'Rewards '}
        </BodyCopy>
      </>
    );
  };

  const renderNewHeader = () => {
    const {
      lbl_create_account_header_title: lblHeaderTitle,
      lbl_create_account_header_title_ca: lblHeaderTitleCA,
      lbl_create_account_subheader_copy1: lblSubHeaderCopy1,
      lbl_create_account_subheader_copy1_ca: lblSubHeaderCopyCA,
      lbl_create_account_subheader_copy2: lblSubHeaderCopy2,
      lbl_create_account_subheader_copy3: lblSubHeaderCopy3,
      lbl_create_account_email_not_found_copy1: lblEmailNotFoundCopy1,
      lbl_create_account_email_not_found_copy2: lblEmailNotFoundCopy2,
    } = getDynamicLabelValues('dynamic.account_d');
    return (
      <>
        <BodyCopy
          className="elem-mt-XXXL"
          textAlign="center"
          fontWeight="extrabold"
          fontSize={['fs18', 'fs24']}
          fontFamily="secondary"
          component={'h1'}
        >
          {!isCanada()
            ? renderLabel(lblHeaderTitle, 'lbl_create_account_header_title')
            : renderLabel(lblHeaderTitleCA, 'lbl_create_account_header_title_ca')}
        </BodyCopy>
        <div className={`header-wrapper ${!emailIsNewRegisteredFlow ? 'elem-mb-XS' : ''} `}>
          {!isCanada() ? (
            <BodyCopy
              component="div"
              className="container right-border"
              textAlign="center"
              fontWeight="semibold"
              fontSize={['fs11', 'fs14']}
              fontFamily="secondary"
            >
              {renderLabel(lblSubHeaderCopy1, 'lbl_create_account_subheader_copy1')}{' '}
              {getMyPlaceRewardsText()}
            </BodyCopy>
          ) : (
            <BodyCopy
              component="div"
              className="container right-border"
              textAlign="center"
              fontWeight="semibold"
              fontSize={['fs11', 'fs14']}
              fontFamily="secondary"
            >
              {renderLabel(lblSubHeaderCopyCA, 'lbl_create_account_subheader_copy1_ca')}
            </BodyCopy>
          )}
          <BodyCopy
            component="div"
            className="container right-border"
            textAlign="center"
            fontWeight="semibold"
            fontSize={['fs11', 'fs14']}
            fontFamily="secondary"
          >
            {renderLabel(lblSubHeaderCopy2, 'lbl_create_account_subheader_copy2')}
          </BodyCopy>
          <BodyCopy
            component="div"
            className="container"
            textAlign="center"
            fontWeight="semibold"
            fontSize={['fs11', 'fs14']}
            fontFamily="secondary"
          >
            {renderLabel(lblSubHeaderCopy3, 'lbl_create_account_subheader_copy3')}
          </BodyCopy>
        </div>
        {emailIsNewRegisteredFlow && (
          <div className="email-container">
            <BodyCopy textAlign="center" fontFamily="secondary" component="div">
              {`${renderLabel(lblEmailNotFoundCopy1, 'lbl_create_account_email_not_found_copy1')} `}
              <BodyCopy
                className="email-link"
                textAlign="center"
                fontFamily="secondary"
                component="span"
                fontWeight="extrabold"
                onClick={() => onBackClick(saveExistingUserResponse, isFromCheckout)}
              >
                {emailIsNewRegisteredFlow}
              </BodyCopy>
            </BodyCopy>
            <BodyCopy textAlign="center" fontFamily="secondary" component="div">
              {renderLabel(lblEmailNotFoundCopy2, 'lbl_create_account_email_not_found_copy2')}
            </BodyCopy>
          </div>
        )}
      </>
    );
  };

  return <div className={className}>{renderNewHeader()}</div>;
};

export default withStyles(CreateAccountNewHeader, Styles);
export { CreateAccountNewHeader as CreateAccountNewHeaderVanilla };
